const REGEX = {
  CITY: /^[a-zA-Z\s\-']+$/,
};

export { REGEX };
